import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinTripIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C8.141 2 5 5.14 5 9C5 13.068 9.63333 19.5841 11.3613 21.7031C11.6903 22.1071 12.3087 22.1071 12.6387 21.7031C14.3657 19.5841 19 13.068 19 9C19 5.14 15.859 2 12 2ZM12 4C14.757 4 17 6.243 17 9C17 11.757 14.757 14 12 14C9.243 14 7 11.757 7 9C7 6.243 9.243 4 12 4ZM12 6C10.343 6 9 7.343 9 9C9 10.657 10.343 12 12 12C13.657 12 15 10.657 15 9C15 8.5 14.5092 8.64873 14.2402 8.80273C14.0222 8.92773 13.77 9 13.5 9C12.672 9 12 8.328 12 7.5C12 7.263 12.0553 7.0398 12.1543 6.8418C12.3053 6.5358 12.559 6 12 6Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinTripIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinTripIcon;
